export interface IAccentColor {
  primaryColor: string;
  primaryDarkColor: string;
  primaryLightColor: string;
  primaryColor2: string;
  secondaryColor: string;
  secondaryDarkColor: string;
  secondaryLightColor: string;
  secondaryColor2: string;
  tertiaryColor: string;
  alertColor: string;
  noticeColor: string;
  starColor: string;
  lineColor: string;
  fbColor: string;
  yahooJapanColor: string;
}

export const accentColor: IAccentColor = {
  // primaryColor: "#8e7043",
  primaryColor: "var(--color-primary)",
  primaryDarkColor: "var(--color-primary--dark)",
  primaryLightColor: "var(--color-primary--light)",
  primaryColor2: "#FAE676",
  secondaryColor: "var(--color-secondary)",
  secondaryDarkColor: "var(--color-secondary--dark)",
  secondaryLightColor: "var(--color-secondary--light)",
  secondaryColor2: "#283C5A",
  tertiaryColor: "#888",
  alertColor: "#ee5244",
  noticeColor: "#eb8523",
  starColor: "#fac83c",
  lineColor: "#06C755",
  fbColor: "#3B5998",
  yahooJapanColor: "#ff0033",
};

export interface ITextColor {
  primaryDarkColor: string;
  secondaryDarkColor: string;
  primaryLightColor: string;
  disabledColor: string;
}

export const textColor: ITextColor = {
  primaryDarkColor: "rgba(45, 45, 45, 1)",
  secondaryDarkColor: "rgba(45, 45, 45, 0.74)",
  primaryLightColor: "rgba(45, 45, 45, 0.5)",
  disabledColor: "rgba(45, 45, 45, 0.38)",
};

export interface IBackgroundColor {
  primaryDarkColor: string;
  secondaryDarkColor: string;
  primaryLightColor: string;
  secondaryLightColor: string;
  thirdlyLightColor: string;
  groundColor: string;
}

export const backgroundColor: IBackgroundColor = {
  primaryDarkColor: "#121212",
  secondaryDarkColor: "#555555",
  primaryLightColor: "#FFFFFF",
  secondaryLightColor: "#EEEEEE",
  thirdlyLightColor: "#E3E3E3",
  groundColor: "#F5F5F5",
};

export interface IBorderColor {
  primaryDarkColor: string;
  primaryLightColor: string;
  secondaryLightColor: string;
}

export const borderColor: IBorderColor = {
  primaryDarkColor: "#AAAAAA",
  primaryLightColor: "#EEEEEE",
  secondaryLightColor: "#CCCCCC",
};

export interface IPostTextColor {
  red: string;
  blue: string;
  green: string;
}

export const postTextColor: IPostTextColor = {
  red: accentColor.secondaryColor,
  blue: accentColor.primaryColor,
  green: "#148a6f",
};

export function shadeColor(color: string, percent: number): string {
  let R: number = parseInt(color.substring(1, 3), 16);
  let G: number = parseInt(color.substring(3, 5), 16);
  let B: number = parseInt(color.substring(5, 7), 16);

  const maxPer = 100;
  const maxVal = 255;

  R = Math.floor((R * (maxPer + percent)) / maxPer);
  G = Math.floor((G * (maxPer + percent)) / maxPer);
  B = Math.floor((B * (maxPer + percent)) / maxPer);

  R = R < maxVal ? R : maxVal;
  G = G < maxVal ? G : maxVal;
  B = B < maxVal ? B : maxVal;

  const RR: string =
    R.toString(16).length === 1 ? `0${R.toString(16)}` : R.toString(16);
  const GG: string =
    G.toString(16).length === 1 ? `0${G.toString(16)}` : G.toString(16);
  const BB: string =
    B.toString(16).length === 1 ? `0${B.toString(16)}` : B.toString(16);

  return `#${RR}${GG}${BB}`;
}

export const hex2rgba = (hex, alpha = 1) => {
  const [r, g, b] = hex.match(/\w\w/g).map((x) => parseInt(x, 16));
  return `rgba(${r},${g},${b},${alpha})`;
};

export const shadeColorLogHex = (hex, alpha, p) => {
  return shadeColorLog(hex2rgba(hex, alpha), p);
};

// https://github.com/PimpTrizkit/PJs/wiki/12.-Shade,-Blend-and-Convert-a-Web-Color-(pSBC.js)
export const shadeColorLog = (rgb, p) => {
  const i = parseInt;
  const r = Math.round;
  const [a, b, c, d] = rgb.split(",");
  const t = p < 0 ? 0 : p * 255 ** 2;
  const P = p < 0 ? 1 + p : 1 - p;
  return (
    "rgb" +
    (d ? "a(" : "(") +
    r((P * i(a[3] == "a" ? a.slice(5) : a.slice(4)) ** 2 + t) ** 0.5) +
    "," +
    r((P * i(b) ** 2 + t) ** 0.5) +
    "," +
    r((P * i(c) ** 2 + t) ** 0.5) +
    (d ? "," + d : ")")
  );
};
